function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFont24 = function SvgFont24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.529,
    height: 18.166
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25804",
    d: "M1.485 2.77A3.668 3.668 0 0 1 2.059.755a3.622 3.622 0 0 1 1.6-1.364 24.417 24.417 0 0 0-3.197-.558A6.856 6.856 0 0 1 1.516-4.84a6.825 6.825 0 0 1 2.852-2.48 9.506 9.506 0 0 1 4.185-.88 8.935 8.935 0 0 1 3.891.806 6.216 6.216 0 0 1 2.62 2.248 6.011 6.011 0 0 1 .93 3.333V9.962h-3.969V-1.384a3.629 3.629 0 0 0-1.038-2.682A3.709 3.709 0 0 0 8.243-5.1a5.413 5.413 0 0 0-2.589.62 3.231 3.231 0 0 0-1.565 1.608 16.348 16.348 0 0 1 2 .558 7.474 7.474 0 0 1 1.6.744v1.116A3.518 3.518 0 0 0 6.027.724a3.04 3.04 0 0 0-.574 1.86v7.378H1.485z",
    transform: "translate(-.463 8.204)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgFont24;